import axiosConfig from '../../components/Conexion/AxiosConexionConfig';
import { apiUsuarioActualizarPlantas } from '../../Config/const';

export class PlantasService {
  async updatePlantasUsuarios(idusuario, plantasUsuario) {
    const url = apiUsuarioActualizarPlantas + `/${idusuario}`;
    try {
      const { data } = await axiosConfig.put(url, plantasUsuario);
      return data;
    } catch (e) {
      throw new Error(e);
    }
  }
}

export const plantasService = new PlantasService();
